const API_KEY = process.env.REACT_APP_API_KEY;

const API_URL = `https://www.themealdb.com/api/json/v1/${API_KEY}/`;

export { API_URL };
